<script lang="ts">
	import { Text, Stack } from '@Shelly/shelly-design-system';
	import type { FlowNode } from '../types/flow-types';

	export let node: FlowNode;
	export let title: string = '';
</script>

<Stack direction="row" gap="m" class="base-inspector">
	{#if title}
		<Text styleType="h2">{title}</Text>
	{/if}

	<!-- Content slot for specific inspector fields -->
	<slot />
</Stack>
